import IOperationSystems from "@/interfaces/IOperationSystems";

const prefixDesktopApp = 'VUE_APP_VERSION_DESKTOP_APP_';
const prefixReleased = `${prefixDesktopApp}RELEASED_`;

const macOS = 'MAC';
const linux = 'LINUX';
const windows = 'WINDOWS';

const desktopApps: { [code: string]: IOperationSystems } = {
    mac: {
        name: 'MacOS',
        version: process.env[`${prefixDesktopApp}${macOS}`],
        released: process.env[`${prefixReleased}${macOS}`],
        icon: 'apple'
    },
    linux: {
        name: 'Linux',
        version: process.env[`${prefixDesktopApp}${linux}`],
        released: process.env[`${prefixReleased}${linux}`],
        icon: 'linux'
    },
    windows: {
        name: 'Windows',
        version: process.env[`${prefixDesktopApp}${windows}`],
        released: process.env[`${prefixReleased}${windows}`],
        icon: 'windows'
    }
};

export default desktopApps;